import initReactComponent from '../../common/utilities/initReactComponent';
import SystemMessageCookie from './SystemMessageCookie';

initReactComponent(SystemMessageCookie, '.js-system-message-cookie');
